import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPentagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFormPentagon"><Path d="M22.1523 8.7002L18.4424 20.1201L18.2734 20.6377H5.72266L5.55371 20.1201L1.84375 8.7002L11.998 1.32324L22.1523 8.7002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormPentagon;
